import * as React from "react";
import { Path, G, ClipPath, Defs, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const SNIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="SN" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#FBCD17"
        fillRule="evenodd"
        d="M5 0h6v12H5V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#006923"
        fillRule="evenodd"
        d="M8.038 7.245 6.295 8.454l.557-2.07-1.28-1.323 1.733-.072.733-2.047.733 2.047h1.73L9.223 6.383l.639 1.949-1.825-1.087Z"
        clipRule="evenodd"
      />
      <Path
        fill="#E11C1B"
        fillRule="evenodd"
        d="M11 0h5v12h-5V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#006923"
        fillRule="evenodd"
        d="M0 0h5v12H0V0Z"
        clipRule="evenodd"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
